/**
 * Resolves a URL typed into a cell to something safe to hand an `href`.
 *
 * A pasted `docs.google.com/…` carries no scheme and would be read as a
 * relative path, navigating the SPA off the board instead of opening the
 * document — so a bare host gets `https://`.
 *
 * One person's `javascript:` value, meanwhile, is a script that every other
 * viewer of the board would run by clicking what looks like a file, so the
 * script-capable schemes resolve to `undefined` and callers render them as
 * plain text. Everything else is left alone: `ftp:`, `slack:` and `notion:`
 * are deep links someone deliberately stored, and refusing them would strip
 * the link off a value that has worked until now.
 */

const SCRIPT_SCHEMES = /^(javascript|data|vbscript|blob|file):/i;

/** A `scheme:` prefix — the digit rules out `host:port`, which is not one. */
const HAS_SCHEME = /^[a-z][\w+.-]*:(?!\d)/i;

export function toHref(value: string): string | undefined {
  const trimmed = value.trim();
  if (trimmed === '') return undefined;
  if (SCRIPT_SCHEMES.test(trimmed)) return undefined;
  return HAS_SCHEME.test(trimmed) ? trimmed : `https://${trimmed}`;
}
